<template>
  <v-container
    v-if="authenticationMixin.checkedLogin"
    class="content pa-0"
    fluid
  >
    <!-- Hero section -->
    <page-hero
      intro="Kies een mini-urne als persoonlijk aandenken."
      title="Mini-urne"
    />

    <!-- Webshop -->
    <v-row justify="center">
      <v-col
        class="center mb-8"
        cols="12"
        lg="10"
      >
        <webshop
          v-if="dossier"
          :betalen="false"
          :dossier="dossier"
          logged-in
          type="miniUrne"
          @success="WebshopSuccess"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import authenticationMixin from '@/mixins/authenticationMixin'
import commonMixin from '@/mixins/commonMixin'
import errorMixin from '@/mixins/errorMixin'
import klantService from '@/services/klantService'
import PageHero from '@/components/PageHero.vue'
import Webshop from '../Webshop.vue'

export default {
  name: 'MiniUrneComponent',
  mixins: [
    authenticationMixin,
    commonMixin,
    errorMixin
  ],
  components: {
    PageHero,
    Webshop
  },
  data () {
    return {
      dossier: null
    }
  },
  mounted () {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    this.AuthenticationMixin_CheckIfLoggedIn()
    this.$store.state.headers.keuzesUitvaart = true
    klantService.Init(this)
    this.GetDossier()
  },
  beforeUnmount () {
    this.$store.state.headers.keuzesUitvaart = false
  },
  methods: {
    async GetDossier () {
      this.CommonMixin_Load(this.$options.name, true)
      const resp = await klantService.GetDossier()

      if (resp && (resp.data || resp.data !== '')) {
        this.dossier = resp.data
      }

      this.CommonMixin_Load(this.$options.name, false)
    },
    WebshopSuccess () {
      this.$router.push('/Uitvaart')
    }
  }
}
</script>
